import { FC } from 'react'
import { Reward } from 'interfaces/bounty'
import TextButton from 'components/atoms/buttons/TextButton'
import LoadingOverlay from 'components/atoms/preloaders/LoadingOverlay'
import * as styles from 'components/features/pfm/RewardDetails/DismissButton.css'

type DismissButtonProps = {
  reward: Reward
  isLoading: boolean
  onClick: () => void
}

const DismissButton: FC<DismissButtonProps> = ({ reward, isLoading, onClick }) => {
  const { is_dismissed, status } = reward

  if (status === 'earned') {
    return null
  }

  if (isLoading) {
    return (
      <div className={ styles.loadingWrapper }>
        <LoadingOverlay />
      </div>
    )
  }

  const copy = is_dismissed
    ? 'Undismiss'
    : 'Dismiss'

  return (
    <TextButton size='regular' onClick={ onClick }>
      { copy }
    </TextButton>
  )
}

export default DismissButton
